import {
  enableProdMode,
  TRANSLATIONS,
  TRANSLATIONS_FORMAT,
} from '@angular/core'
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic'

import { AppModule } from './app/app.module'
import { environment } from '@env/environment'
/**
 * Standard locale
 */
const LOCALE_ID = `${environment.prefix}_locale_id`
/**
 * Require variable
 */
declare const require

if (environment.production) {
  enableProdMode()
}
/**
 * Boostrap the application
 */
platformBrowserDynamic()
  .bootstrapModule(AppModule, { providers: getProviderI18n() })
  .catch((err) => console.log(err))

/**
 * Returns the translation provider for angular i18n
 * @returns {Array}
 */
export function getProviderI18n() {
  const locale = localStorage.getItem(LOCALE_ID)
  if (locale) {
    try {
      const translations =
        require(`raw-loader!./assets/locale/messages.${locale}.xlf`).default
      if (translations) {
        return [
          { provide: TRANSLATIONS, useValue: translations },
          { provide: TRANSLATIONS_FORMAT, useValue: 'xlf' },
        ]
      }
    } catch (error) {
      return []
    }
  }
  return []
}
